import { unzipSync } from "fflate";
import GeoJSON from "ol/format/GeoJSON.js";
import GPX from "ol/format/GPX.js";
import KML from "ol/format/KML.js";
import DragAndDrop from "ol/interaction/DragAndDrop.js";
import VectorImageLayer from "ol/layer/VectorImage.js";
import VectorSource from "ol/source/Vector.js";

let zip;

function getKMLData(buffer) {
  zip = unzipSync(new Uint8Array(buffer));

  const kml = Object.keys(zip).find((key) => /\.kml$/i.test(key));
  if (!(kml in zip)) {
    return null;
  }

  return new TextDecoder().decode(zip[kml]);
}

function getKMLImage(href) {
  const index = window.location.href.lastIndexOf("/");
  if (index === -1) {
    return href;
  }

  const image = href.slice(index + 1);
  if (!(image in zip)) {
    return href;
  }

  return URL.createObjectURL(new Blob([zip[image]]));
}

class KMZ extends KML {
  constructor(opt_options) {
    const options = opt_options || {};
    options.iconUrlFunction = getKMLImage;
    super(options);
  }

  getType() {
    return "arraybuffer";
  }

  readFeature(source, options) {
    const kmlData = getKMLData(source);
    return super.readFeature(kmlData, options);
  }

  readFeatures(source, options) {
    const kmlData = getKMLData(source);
    return super.readFeatures(kmlData, options);
  }
}

export function configurarDragAndDrop(map) {
  const dragAndDropInteraction = new DragAndDrop({
    formatConstructors: [GeoJSON, KML, KMZ, GPX],
  });

  map.addInteraction(dragAndDropInteraction);

  dragAndDropInteraction.on("addfeatures", function (event) {
    const vectorSource = new VectorSource({
      features: event.features,
    });

    map.addLayer(
      new VectorImageLayer({
        source: vectorSource,
      })
    );
    map.getView().fit(vectorSource.getExtent());
  });
}
